import React, { useEffect } from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Chip from '@material-ui/core/Chip';
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import styles from "assets/jss/material-kit-react/components/profileStyle.js";
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@material-ui/core/InputAdornment';
import Axios from "axios";
import Config from "../../config.js"
import swal from 'sweetalert'


const useStyles = makeStyles(styles);

export default function Honors(props) {
  const { user } = props;
  const classes = useStyles();
  const [state, setState] = React.useState({
    honors: user && user.honors,
    title: ""
  });
  var Call = () => {
    Axios.post(Config.api + "Authentication/CompleteRegistration", {
      honors:state.honors,
    },
      {
        headers: {
          apikey: Config.apikey,
          Authorization: "Bearer " + localStorage.getItem('token')
        }
      }).then((result) => {
        swal("با موفقیت انجام شد.");
      }).catch((err) => {
        if (err&&err.response&&err.response.status&&err.response.status == 422)
          swal("پارامترهای ارسالی نادرست است.");
          else if(err&&err.response&& err.response.data&&err.response.data.fa_message){
          swal(err.response.data.fa_message);
          }
        else if (err&&err.response&&err.response.data&&err.response.data.message&&err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")
      })
  }
  const handleTextBoxChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };
  const removeFromList = (source, tttt, valueToRemove) => {
    var e = source.filter(item => item !== valueToRemove)
    setState({ ...state, [tttt]: e })
  };

  const addToHonorsList = () => {
    if (state.title == "")
      return swal("عنوان نمی تواند خالی باشد.");
    state.honors.push(state.title)
    setState({ ...state, "honors": state.honors })
    setState({ ...state, "title": ""})
  };
  return (
    <form noValidate autoComplete="off">
      <GridContainer className={classes.root} justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <Paper className={classes.paper} variant="outlined" >

            <GridContainer>
              <GridItem xs={12} sm={12} md={5}>
                <div className={classes.div}>
                  <Typography variant="h6" gutterBottom>
                    افتخارات
      </Typography>
                  <div className={classes.formInput}>
                    <TextField id="standard-basic" name="title" value={state.title} onChange={handleTextBoxChange} label="عنوان" helperText="مثال: رتبه سوم دومین دوره ماراتن ملی موبایل ایران" />
                  </div>
                  <br />
                  <div className={classes.formInput}>
                    <Button variant="outlined" color="secondary" disableElevation onClick={addToHonorsList}>
                      افزودن به لیست
</Button>
                  </div>
                </div>
              </GridItem>
              <GridItem xs={12} sm={12} md={7}>
                <div className={classes.div}>
                {user && state.honors.length > 0 ? (
                  <div className={classes.formInput+" "+classes.chipMargin}>
                        {user && state.honors.map((honor) => {
                          return (
                            <Chip variant='outlined' label={honor} onDelete={() => { removeFromList(state.honors, 'honors', honor) }} color="primary"  />
                          );
                        })}
                  </div>
                ) : <p><br/>موردی جهت نمایش وجود ندارد.</p>}
                </div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.en +" " +classes.save}>
                <Button variant="contained" color="primary" disableElevation onClick={Call}>
                     ذخیره سازی
</Button>
                </div>
              </GridItem>
            </GridContainer>
          </Paper>
        </GridItem>
</GridContainer>
    </form>
  );
}